<template>
  <div class="bgf5">
    <iHeader />
    <iNav />
    <iClassify
      :active="8"
      all-active
    />
    <iRightFixedBox />
    <div class="container">
      <div class="pb20">
        <iPageTitle :text="pageTitle" />
      </div>
      <div class="w1200 bgfff">
        <div>
          <van-image
            :src="require('@/assets/mine/lingquan-banner.png')"
            width="100%"
            height="400px"
          />
        </div>
        <div class="pl30 pr30 pb30 pt30">
          <van-image
            :src="require('@/assets/mine/lingquanzhongxin-title.png')"
            width="100%"
            height="72px"
          />
        </div>
        <div class="mb100 pl30 pr30 pb30">
          <NewiCoupon
            v-if="coupons.length"
            :loading="loading"
            :data="coupons"
            :type="2"
            :is-get="true"
            page="VoucherCenter"
            @handleDraw="handleDraw"
          />
          <EmptyControl
            v-if="!coupons.length && finished"
            style="padding-top: 100px;"
            type="coupon"
            text="暂无优惠券哦～"
          />
        </div>
      </div>
    </div>
    <iFooter />
    <!-- 对话框 -->
    <iDialog
      ref="iDialogref"
      :show-cancel-btn="false"
      confirm-btn-text="确定"
      width="607px"
    >
      <template #bottom>
        <div class="pb10">
          <van-icon
            size="90px"
            :name="require('@/assets/mine/fankui-success-icon.png')"
            class="mt108"
          />
          <div class="f26 c0F6EEA fw600 mb10 mt30">领取成功</div>
          <div class="c777 f14 mb5">可以前往我的优惠券查看详情！</div>
        </div>
      </template>
    </iDialog>
  </div>
</template>

<script>
import { LinkTypeCode } from '@/dictionary/base.js'
import iRightFixedBox from '@/components/RightFixedBox'
import iHeader from '@/components/Header'
import iNav from '@/components/Nav'
import iClassify from '@/components/Classify'
import iFooter from '@/components/Footer'
import NewiCoupon from '@/components/NewiCoupon'
import { BaseMixin } from '../../mixins/BaseMixin.js'
import iDialog from '@/components/iDialog'
import iPageTitle from '@/components/PageTitle'
export default {
  name: 'VoucherCenter',
  components: {
    iHeader,
    iNav,
    iFooter,
    iClassify,
    NewiCoupon,
    iDialog,
    iPageTitle,
    iRightFixedBox
  },
  mixins: [BaseMixin],
  data() {
    return {
      pageTitle: ['领券中心'],
      loading: false,
      refreshing: false,
      finished: false,
      coupons: [],
      offsetTop: 0,
      navbarHeight: 0
    }
  },
  mounted() {
    this.onLoad()
  },
  methods: {
    // 返回
    goBack() {
      this._back()
      this.$bus.$emit('refreshCoupon')
    },
    // 前往我的优惠券
    onClickRight() {
      this._go('MyCoupon', null, null, true)
    },
    async onLoad() {
      await this.getCoupons()
      // 数据全部加载完成
      this.finished = true
    },
    // 获取优惠券列表
    async getCoupons() {
      this.loading = true
      this.$hys.openLoading()
      const res = await this.getAction('/api_coupon/Coupon/GetCoupons', {
        goodsId: '',
        pageNo: 1,
        pageSize: 9999
      })
      this.$hys.clearLoading()
      this.loading = false
      if (res.IsSuccess && res.Data) {
        const couponsArr = []
        res.Data.map(item => {
          const lrt = parseFloat(item.OutCouponDto.OutCouponIssueDto.DeductionLimit * 10)
            .toFixed(2)
            .toString()
          const l = {
            ...item,
            IsReceive: item.OutCouponDto.IsReceive,
            IsUse: item.OutCouponDto.IsUse,
            Goods: item.OutCouponDto.OutCouponIssueDto.OutCouponLimitGoodsDtos,
            UseRequire: item.OutCouponDto.OutCouponIssueDto.OutCouponUseRequireDto,
            DeductionMode: item.OutCouponDto.OutCouponIssueDto.DeductionMode, // 指定金额1，指定比例2，全额抵扣3
            DeductionLimit: item.OutCouponDto.OutCouponIssueDto.DeductionLimit,

            LimitF: item.OutCouponDto.OutCouponIssueDto.DeductionMode == 2 ? (lrt.indexOf('.') == -1 ? lrt : lrt.substring(0, lrt.indexOf('.'))) : null,

            LimitL:
                            item.OutCouponDto.OutCouponIssueDto.DeductionMode == 2
                              ? lrt.indexOf('.') == -1
                                ? null
                                : lrt.substring(lrt.indexOf('.'), lrt.length).replace(/0/, '')
                              : null,
            loading: false
          }
          couponsArr.push(l)
        })
        this.coupons = couponsArr
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    //
    handleDraw() {
      this.$refs.iDialogref.iShow()
      this.onLoad()
    }
  }
}
</script>

<style scoped lang="less">
.container {
  > div {
    margin: 0 auto;
  }
}

/deep/.van-dialog /deep/ .van-dialog__footer {
  padding-bottom: 70px;
}

/deep/.i-col {
  > .van-row {
    margin-bottom: 30px;
  }
}
</style>
